import { usePageStore } from "@voix/store/pageStore";
import { useNuxtApp } from "#imports";
export class PageField {
  fieldConfig;
  fieldValue;
  config;
  value;
  constructor(fieldConfig, value) {
    this.fieldConfig = fieldConfig;
    this.fieldValue = value;
    this.config = {};
    this.value = null;
  }
}
export function usePageField() {
  const { $voix } = useNuxtApp();
  const pageStore = usePageStore();
  function get(fieldName, defaultValue = null) {
    const fieldConfig = $voix.options.pageFields[fieldName];
    if (!pageStore.currentPage) {
      const fieldValue2 = {};
      const pageFieldClass2 = new PageField(fieldConfig, fieldValue2);
      return new Proxy(pageFieldClass2, {
        get(target, property) {
          if (typeof fieldValue2 === "undefined")
            return defaultValue;
          if (property === "enabled")
            return Object.prototype.hasOwnProperty.call(fieldConfig, "enabled") ? target.fieldValue.enabled : true;
          if (property === "config")
            return target.fieldConfig;
          if (property === target.fieldValue.type || property === "value")
            return target.fieldConfig.default;
        }
      });
    }
    const fieldValue = pageStore.currentPage.fields.find((field) => field.name === fieldName);
    const pageFieldClass = new PageField(fieldConfig, fieldValue);
    return new Proxy(pageFieldClass, {
      get(target, property) {
        if (typeof fieldValue === "undefined")
          return defaultValue;
        if (property === "enabled")
          return Object.prototype.hasOwnProperty.call(fieldConfig, "enabled") ? target.fieldValue.enabled : true;
        if (property === "config")
          return target.fieldConfig;
        if (property in target.fieldValue)
          return target.fieldValue[property];
        if (property === target.fieldValue.type || property === "value") {
          if (target.fieldValue.type && typeof target.fieldValue[target.fieldValue.type] !== "undefined")
            return target.fieldValue[target.fieldValue.type];
          else return target.fieldConfig.default;
        }
      }
    });
  }
  return { get };
}
